import { c as _c } from "react/compiler-runtime";
import { formatCents } from 'betterplace-utils';
import classNames from 'classnames';
import { useTranslations, useLocale } from 'next-intl';
import { AmountCSSProperties } from './types';
function Amount(t0) {
  const $ = _c(13);
  const {
    amount,
    showPlaceholder: t1,
    style,
    className
  } = t0;
  const showPlaceholder = t1 === undefined ? false : t1;
  const locale = useLocale();
  const t = useTranslations("nextjs.streambot");
  let t2;
  if ($[0] !== showPlaceholder || $[1] !== t) {
    t2 = showPlaceholder ? t("amount_fallback") : null;
    $[0] = showPlaceholder;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const fallback = t2;
  let t3;
  if ($[3] !== className) {
    t3 = classNames("listAmount", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== amount || $[6] !== fallback || $[7] !== locale) {
    t4 = amount ? formatCents(locale, amount) : fallback;
    $[5] = amount;
    $[6] = fallback;
    $[7] = locale;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== style || $[10] !== t3 || $[11] !== t4) {
    t5 = <div style={style} className={t3}>{t4}</div>;
    $[9] = style;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default Amount;